import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimatedDigitComponent } from '../../content/pages/solde/animated-digit/animated-digit.component';
import { DeclencherComponent } from '../../content/pages/campagne/declencher/declencher.component';
import { SuiviComponent } from '../../content/pages/campagne/suivi-eia/suivi.component';
import { ReportingComponent } from '../../content/pages/campagne/reporting/reporting.component';
import { SubheaderComponent } from '../../content/layout/components/subheader/subheader.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { Ng2OrderModule } from 'ng2-order-pipe';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgbModule, NgbActiveModal, NgbTabsetModule } from '@ng-bootstrap/ng-bootstrap';
import { TopTenFlopTenComponent } from '../../content/pages/campagne/reporting/features/top-ten-flop-ten/top-ten-flop-ten.component';
import { TauxExecutionComponent } from '../../content/pages/campagne/reporting/features/taux-execution/taux-execution.component';
import { PerformanceComponent } from '../../content/pages/campagne/reporting/features/performance/performance.component';
import { DelaiExecutionComponent } from '../../content/pages/campagne/reporting/features/delai-execution/delai-execution.component';
import { AnalyseEiaComponent } from '../../content/pages/campagne/reporting/features/analyse-eia/analyse-eia.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { DeclencherOfaComponent } from '../../content/pages/campagne/declencher-ofa/declencher-ofa.component';
import { ExcelService } from '../services/excel.service';
import { SwalService } from '../services/swal.service';
import { FormationsComponent } from '../../content/pages/campagne/reporting/features/formations/formations.component';
import { CompetencesComponent } from '../../content/pages/campagne/reporting/features/competences/competences.component';
import { EtatEiaComponent } from '../../content/pages/campagne/reporting/features/etat-eia/etat-eia.component';
import { SharedDataService } from '../services/shared-data.service';
import { MesPropositionsComponent } from '../../content/pages/mes-ofa/ui/mes-propositions/mes-propositions.component';
import { MonArbitrageComponent } from '../../content/pages/mes-ofa/ui/mon-arbitrage/mon-arbitrage.component';
import { SoldeComponent } from '../../content/pages/solde/solde.component';
import { SoldeAnalyseComponent } from '../../content/pages/campagne/suivi-ofa/features/solde-analyse/solde-analyse.component';
import { SoldeArbitrageComponent } from 'src/app/content/pages/mes-ofa/ui/mon-arbitrage/solde-arbitrage/solde-arbitrage.component';
import { PipesModule } from '../pipes/pipes.module';

/*   EIA  2023  @ */
import { DetailsOfaComponent } from 'src/app/content/pages/mes-ofa/features/details-ofa/details-ofa.component';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { DecimalPipe } from '@angular/common';
import { SidebarModule } from 'primeng/sidebar';
import { InputTextareaModule } from 'primeng/inputtextarea';
/*   EIA  2023   */

import { HistoriqueCompetenceComponent } from 'src/app/content/pages/consultation/features/fiche-evaluation-historique/wrappers/historique-competence/historique-competence.component';
import { HistoriqueFormationComponent } from 'src/app/content/pages/consultation/features/fiche-evaluation-historique/wrappers/historique-formation/historique-formation.component';
import { HistoriqueCarriereComponent } from 'src/app/content/pages/consultation/features/fiche-evaluation-historique/wrappers/historique-carriere/historique-carriere.component';
import { HistoriqueSyntheseComponent } from 'src/app/content/pages/consultation/features/fiche-evaluation-historique/wrappers/historique-synthese/historique-synthese.component';
import { HistoriqueSavoirEtreComponent } from 'src/app/content/pages/consultation/features/fiche-evaluation-historique/wrappers/tenue-poste/historique-savoir-etre/historique-savoir-etre.component';
import { HistoriqueSavoirFaireComponent } from 'src/app/content/pages/consultation/features/fiche-evaluation-historique/wrappers/tenue-poste/historique-savoir-faire/historique-savoir-faire.component';
import { FicheEvaluationHistoriqueComponent } from 'src/app/content/pages/consultation/features/fiche-evaluation-historique/fiche-evaluation-historique.component';
import { HistoriquePerformanceComponent } from 'src/app/content/pages/consultation/features/fiche-evaluation-historique/wrappers/historique-performance/historique-performance.component';
import { HistoriqueObjectifAnneeSuivanteComponent } from 'src/app/content/pages/consultation/features/fiche-evaluation-historique/wrappers/historique-objectif-annee-suivante/historique-objectif-annee-suivante.component';
import { RapportBoxComponent } from 'src/app/content/pages/evaluation/features/rapport-box/rapport-box.component';
import { TruncatePipe } from '../directives/truncate.pipe';
import { FormationWrapperComponent } from 'src/app/content/pages/fiche-evaluation/formation/formation-wrapper.component';
import { TagInputModule } from 'ngx-chips';
import { DynamicFieldComponent } from '../components/dynamic-field/dynamic-field.component';
import { LoaderService } from '../services/loader.service';
import { StatsComponent } from '../components/stats/stats.component';
import { FilterComponent } from '../components/filter/filter.component';
import { TabContentComponent } from '../components/tab-content/tab-content.component';
import { TableComponent } from '../components/table/table.component';
import { TabsComponent } from '../components/tabs/tabs.component';
import { SpinnerComponent } from '../components/spinner/spinner.component';
import { FormComponent } from '../components/form/form.component';
import { FormFieldComponent } from '../components/form-field/form-field.component';
import { BreadcrumbComponent } from '../components/breadcrumb/breadcrumb.component';
import { DetailsComponent } from '../components/details/details.component';
import { SafePipe } from '../pipes/safe.pipe';
import { OfaStatusComponent } from 'src/app/content/pages/mes-ofa/features/ofa-status.component';
import { TitleComponent } from '../components/title/title.component';
import { NgxMaskModule } from 'ngx-mask';
import { FileUploadService } from '../services/file-upload.service';
import { HistoriquesWrapperComponent } from '../components/historiques-wrapper/historiques-wrapper.component';
import { FormatFieldName } from 'src/app/content/pages/campagne/fomatFieldName';
import { Select2Module } from 'ng-select2-component';
import { NgSelectModule } from '@ng-select/ng-select';
/*   EIA  2023   */
import { Daterangepicker } from 'ng2-daterangepicker';
import { SafeJsonParsePipe } from '../pipes/safe-json-parse.pipe';
import { LogsFormationComponent } from 'src/app/content/pages/fiche-evaluation/formation/features/logs-formation.component';
import {
  AutreFormationsComponent
} from '../../content/pages/fiche-evaluation/formation/features/autre-formations/autre-formations.component';
import {
  InitierFormationsComponent
} from '../../content/pages/fiche-evaluation/formation/features/initier-formations/initier-formations.component';
import { RatingComponent } from '../../content/pages/fiche-evaluation/formation/features/rating/rating.component';
import {
  DetailsFormationsComponent
} from '../../content/pages/fiche-evaluation/formation/features/initier-formations/details-formations/details-formations.component';
import { CasRhComponent } from 'src/app/content/pages/campagne/agents-eia/features/cas-rh/cas-rh.component';
import {ParentComponent} from '../../content/pages/test/parent.component';
import {
  SendBulkEmailComponent
} from '../../content/pages/campagne/agents-eia/features/send-bulk-email/send-bulk-email.component';
import {SendEmailComponent} from '../../content/pages/campagne/agents-eia/features/send-email/send-email.component';
import {
  SendBulkEmailOfaComponent
} from '../../content/pages/campagne/agents-ofa/features/send-bulk-email/send-bulk-email.component';
import {SendEmailOfaComponent} from '../../content/pages/campagne/agents-ofa/features/send-email/send-email.component';
import {SimulationComponent} from '../../content/pages/consultation/simulation/simulation.component';
import { ObjectifTabComponent } from './components/objectif-tab/objectif-tab.component';
import { ObjectifContentComponent } from 'src/app/content/pages/fiche-evaluation/objectif-global/objectif-content/objectif-content.component';

@NgModule({
  imports: [
    Daterangepicker,
    NgSelectModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    Ng2SearchPipeModule,
    Ng2OrderModule,
    NgbModule,
    AngularMultiSelectModule,
    PipesModule,
    NgxSpinnerModule,
    InputTextModule,
    ButtonModule,
    DropdownModule,
    SidebarModule,
    InputTextareaModule,
    TagInputModule,
    Select2Module,
    NgxMaskModule.forRoot({
      thousandSeparator: ' '
    }),
  ],

  declarations: [
    LogsFormationComponent,
    ObjectifTabComponent,
    SafeJsonParsePipe,
    SafePipe,
    TruncatePipe,
    SoldeComponent,
    SendBulkEmailComponent,
    SendBulkEmailOfaComponent,
    SendEmailComponent,
    SimulationComponent,
    SendEmailOfaComponent,
    HistoriquesWrapperComponent,
    DeclencherComponent,
    DeclencherOfaComponent,
    SuiviComponent,
    ReportingComponent,
    SubheaderComponent,
    AnimatedDigitComponent,
    TopTenFlopTenComponent,
    TauxExecutionComponent,
    PerformanceComponent,
    DelaiExecutionComponent,
    FormationsComponent,
    CompetencesComponent,
    AnalyseEiaComponent,
    EtatEiaComponent,
    MesPropositionsComponent,
    MonArbitrageComponent,
    SoldeAnalyseComponent,
    SoldeArbitrageComponent,
    CasRhComponent,
    DetailsOfaComponent,
    HistoriqueCompetenceComponent,
    HistoriqueFormationComponent,
    HistoriqueCarriereComponent,
    HistoriqueSyntheseComponent,
    HistoriqueSavoirEtreComponent,
    HistoriqueSavoirFaireComponent,
    FicheEvaluationHistoriqueComponent,
    HistoriquePerformanceComponent,
    HistoriqueObjectifAnneeSuivanteComponent,
    RapportBoxComponent,
    FormationWrapperComponent,
    DynamicFieldComponent,
    StatsComponent,
    DetailsComponent,
    FormComponent,
    BreadcrumbComponent,
    FormFieldComponent,
    FilterComponent,
    TabContentComponent,
    OfaStatusComponent,

    TableComponent,
    TabsComponent,
    SpinnerComponent,
    TitleComponent,
    AutreFormationsComponent,
    InitierFormationsComponent,
    RatingComponent,
    DetailsFormationsComponent,
    ParentComponent,

    ObjectifContentComponent
  ],

  entryComponents: [
    CasRhComponent,
    DetailsOfaComponent,
    LogsFormationComponent,
    InitierFormationsComponent,
    DetailsFormationsComponent,
    RatingComponent,
  ],

  providers: [
    NgbActiveModal,
    NgbTabsetModule,
    ExcelService,
    SwalService,
    SharedDataService,
    DecimalPipe,
    LoaderService,
    FileUploadService,
    FormatFieldName
  ],

  exports: [
    NgxPaginationModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    Daterangepicker,
    NgSelectModule,
    HistoriquesWrapperComponent,
    StatsComponent,
    OfaStatusComponent,
    DetailsComponent,
    FormComponent,
    BreadcrumbComponent,
    FormFieldComponent,
    FilterComponent,
    TabContentComponent,
    ObjectifTabComponent,
    TableComponent,
    TabsComponent,
    SpinnerComponent,
    TitleComponent,
    ParentComponent,
    SoldeComponent,
    AnimatedDigitComponent,
    DeclencherComponent,
    DeclencherOfaComponent,
    SuiviComponent,
    ReportingComponent,
    SubheaderComponent,
    TopTenFlopTenComponent,
    TauxExecutionComponent,
    PerformanceComponent,
    DelaiExecutionComponent,
    AnalyseEiaComponent,
    FormationsComponent,
    ObjectifContentComponent,
    CompetencesComponent,
    EtatEiaComponent,
    MesPropositionsComponent,
    MonArbitrageComponent,
    SoldeAnalyseComponent,
    SoldeArbitrageComponent,
    HistoriqueCompetenceComponent,
    HistoriqueFormationComponent,
    HistoriqueCarriereComponent,
    HistoriqueSyntheseComponent,
    HistoriqueSavoirEtreComponent,
    HistoriqueSavoirFaireComponent,
    FicheEvaluationHistoriqueComponent,
    HistoriquePerformanceComponent,
    HistoriqueObjectifAnneeSuivanteComponent,
    LogsFormationComponent,
    RatingComponent,
    FormationWrapperComponent,
    AutreFormationsComponent,
    InitierFormationsComponent,
    DynamicFieldComponent,
    DetailsOfaComponent,
    CasRhComponent,
    InputTextModule,
    ButtonModule,
    DropdownModule,
    SidebarModule,
    DecimalPipe,
    RapportBoxComponent,
    InputTextareaModule,
    TruncatePipe,
    TagInputModule,
    AngularMultiSelectModule,
    SafePipe,
    NgxMaskModule,
    Select2Module,
    SafeJsonParsePipe
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
})
export class SharedModule { }
